var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.hasInvoice
      ? _c(
          "div",
          [
            _c("h3", { staticClass: "mt-0" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__("Afficher les types de documents non utilisés")
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "explain" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Si vous nʼutilisez jamais certains types de documents et vous contentez, par exemple, des devis et factures, vous avez la possibilité de masquer certains types de documents afin d’alléger votre interface Sellsy. Vous pourrez à tout moment décider de les afficher à nouveau depuis cette même page."
                    )
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "el-checkbox-group",
              {
                model: {
                  value: _vm.doctypes,
                  callback: function($$v) {
                    _vm.doctypes = $$v
                  },
                  expression: "doctypes"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("el-checkbox", { attrs: { label: "order" } }, [
                      _vm._v(
                        _vm._s(_vm.$l10n.__("Afficher les bons de commande"))
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("el-checkbox", { attrs: { label: "delivery" } }, [
                      _vm._v(
                        _vm._s(_vm.$l10n.__("Afficher les bons de livraison"))
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("el-checkbox", { attrs: { label: "proforma" } }, [
                      _vm._v(
                        _vm._s(_vm.$l10n.__("Afficher les factures proforma"))
                      )
                    ])
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("h3", [
      _vm._v(
        "\n        " +
          _vm._s(
            _vm.$l10n.__("Date de validité des devis et factures proforma")
          ) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex-level mt-3" },
      [
        _c("span", [
          _vm._v(
            _vm._s(_vm.$l10n.__("Un devis ou une facture proforma expire sous"))
          )
        ]),
        _vm._v(" "),
        _c("el-input-number", {
          staticClass: "dinlineb mx-2 input-small",
          attrs: { min: 1 },
          model: {
            value: _vm.expirationTime,
            callback: function($$v) {
              _vm.expirationTime = $$v
            },
            expression: "expirationTime"
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$l10n.__("jour(s)")))])
      ],
      1
    ),
    _vm._v(" "),
    _c("h3", [
      _vm._v("\n        " + _vm._s(_vm.$l10n.__("Liens publics")) + "\n    ")
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n        " +
          _vm._s(
            _vm.$l10n.__(
              "Définir si les liens publics de vos documents sont actifs par défaut."
            )
          ) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c(
          "el-checkbox",
          {
            model: {
              value: _vm.publicLink,
              callback: function($$v) {
                _vm.publicLink = $$v
              },
              expression: "publicLink"
            }
          },
          [_vm._v(_vm._s(_vm.$l10n.__("Liens publics actifs par défaut")))]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("h3", [
      _vm._v(
        "\n        " + _vm._s(_vm.$l10n.__("Gestion des reliquats")) + "\n    "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n        " +
          _vm._s(
            _vm.$l10n.__(
              "La gestion des reliquats vous permet de calculer dynamiquement les quantités de vos documents en fonctions de leur historique."
            )
          ) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "alert alert-warning" }, [
      _c("p", [
        _vm._v(
          "\n            " +
            _vm._s(
              _vm.$l10n.__(
                "Attention, une fois la gestion des reliquats activée, les lignes identiques des documents seront regroupées lors des conversions dans le but de calculer les quantités restantes. Cette option est incompatible avec les produits sérialisés."
              )
            ) +
            "\n        "
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c(
          "el-checkbox",
          {
            model: {
              value: _vm.reliquat,
              callback: function($$v) {
                _vm.reliquat = $$v
              },
              expression: "reliquat"
            }
          },
          [_vm._v(_vm._s(_vm.$l10n.__("Activer la gestion des reliquats")))]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt-3" },
      [
        _c("CompassButton", {
          attrs: { label: _vm.$t.__("common.actions.save") },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.save($event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }